$('.form').submit(function (e) {
    $('#Response').val($('#g-recaptcha-response').val());
});

var resetCaptcha = function () {
    grecaptcha.reset();
    $('#Response').val("");
};

var submitForm = function () {
    $('.form').submit();
};

var validateForm = function () {
    //si form dynamique avec des listes
    //website.form.resetIndex([
    //    { selector: '.student', name: 'Students' },
    //]);

    var validate = $(".form").validate();

    if ($('.form').valid())
        grecaptcha.execute();
    else
        validate.focusInvalid();
};

var showLoading = function () {
    $('#ajaxLoading').fadeIn();
};

var hideLoading = function () {
    $('#ajaxLoading').fadeOut();
};
